import { getParkingSessionsEndpoint, ParkingSessions } from 'cpfr-common';
import { getSimpleDataFetchSlice } from '@cp-shared-19/frontend-integration';
import { CpDataApi } from 'cp-xhr';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';

const { reducer, fetchData } = getSimpleDataFetchSlice<ParkingSessions, DefaultBusinessMarketApiErrorCode>({
    dataName: 'parkingSessions',
    fetchCallback() {
        return CpDataApi.get(getParkingSessionsEndpoint()).then((response) => response.data);
    },
});

export default reducer;
export const fetchParkingSessions = fetchData;
